/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 9.5L8.4 9V9C6.73947 7.61623 5.90921 6.92434 5.63221 6.39878C4.80779 4.83458 5.5081 2.90028 7.14281 2.22641C7.69206 2 8.77283 2 10.9344 2H12H13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15 14.5L15.6 15V15C17.2605 16.3838 18.0908 17.0757 18.3678 17.6012C19.1922 19.1654 18.4919 21.0997 16.8572 21.7736C16.3079 22 15.2272 22 13.0656 22H12C8.96159 22 7.44239 22 6.72234 21.5602C5.52426 20.8284 4.99392 19.3635 5.44581 18.0343C5.7174 17.2355 6.88448 16.2629 9.21865 14.3178L15.1655 9.36212C17.183 7.68087 18.1917 6.84025 18.4752 6.17251C19.0896 4.72556 18.4829 3.04971 17.0846 2.33146C16.4393 2 15.1262 2 12.5 2V2H12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M14.7813 9.68221L12 12L14.7814 14.3178L14.7814 14.3178C17.1155 16.2629 18.2826 17.2355 18.5542 18.0343C19.0061 19.3635 18.4757 20.8284 17.2777 21.5602C16.5576 22 15.0384 22 12 22C8.96159 22 7.44239 22 6.72234 21.5602C5.52426 20.8284 4.99392 19.3635 5.44581 18.0343C5.7174 17.2355 6.88448 16.2629 9.21865 14.3178L12 12L9.21865 9.68221C6.88449 7.73707 5.7174 6.7645 5.44581 5.96565C4.99392 4.63647 5.52426 3.17164 6.72234 2.43983C7.44239 2 8.96159 2 12 2C15.0384 2 16.5576 2 17.2777 2.43983C18.4757 3.17164 19.0061 4.63647 18.5542 5.96565C18.2826 6.7645 17.1155 7.73707 14.7813 9.68221Z"
				fill="currentColor"
			/>
			<path
				d="M15 14.5L15.6 15V15C17.2605 16.3838 18.0908 17.0757 18.3678 17.6012C19.1922 19.1654 18.4919 21.0997 16.8572 21.7736C16.3079 22 15.2272 22 13.0656 22H12C8.96159 22 7.44239 22 6.72234 21.5602C5.52426 20.8284 4.99392 19.3635 5.44581 18.0343C5.7174 17.2355 6.88448 16.2629 9.21865 14.3178L14.7813 9.68221C17.1155 7.73707 18.2826 6.7645 18.5542 5.96565C19.0061 4.63647 18.4757 3.17164 17.2777 2.43983C16.5576 2 15.0384 2 12 2H10.9344C8.77283 2 7.69206 2 7.14281 2.22641C5.5081 2.90028 4.80779 4.83458 5.63221 6.39878C5.90921 6.92434 6.73947 7.61623 8.4 9V9L9 9.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<g clipPath="url(#clip0_2004_793)">
				<path
					d="M12 1.25C8.39609 1.25 6.59414 1.25 5.74423 1.77977C4.37436 2.63364 3.76612 4.31362 4.27185 5.84655C4.58562 6.79763 5.96992 7.95121 8.73852 10.2584L9.40399 10.8129C9.86376 11.1961 10.0936 11.3876 10.1881 11.612C10.2925 11.8601 10.2925 12.1399 10.1881 12.388C10.0936 12.6124 9.86376 12.8039 9.40399 13.1871L8.73852 13.7416C5.96992 16.0488 4.58562 17.2024 4.27185 18.1535C3.76612 19.6864 4.37436 21.3664 5.74423 22.2202C6.59414 22.75 8.3961 22.75 12 22.75C15.6039 22.75 17.4059 22.75 18.2558 22.2202C19.6256 21.3664 20.2339 19.6864 19.7282 18.1535C19.4144 17.2024 18.0301 16.0488 15.2615 13.7416L14.596 13.1871C14.1363 12.8039 13.9064 12.6124 13.8119 12.388C13.7075 12.1399 13.7075 11.8601 13.8119 11.612C13.9064 11.3876 14.1363 11.1961 14.596 10.8129L15.2615 10.2584C18.0301 7.95121 19.4144 6.79763 19.7282 5.84655C20.2339 4.31362 19.6256 2.63364 18.2558 1.77977C17.4059 1.25 15.6039 1.25 12 1.25Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_793">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M15 14.5L15.6 15C17.2605 16.3838 18.0908 17.0757 18.3678 17.6012C19.1922 19.1654 18.4919 21.0997 16.8572 21.7736C16.3079 22 15.2271 22 13.0656 22H12C8.96156 22 7.44235 22 6.7223 21.5602C5.52422 20.8284 4.99388 19.3635 5.44577 18.0343C5.71737 17.2355 6.88445 16.2629 9.21861 14.3178L13.2 11M8.99996 9.5L8.39996 9C6.73943 7.61623 5.90917 6.92434 5.63217 6.39878C4.80775 4.83458 5.50806 2.90028 7.14277 2.22641C7.69202 2 8.77279 2 10.9343 2H12C15.0384 2 16.5576 2 17.2776 2.43983C18.4757 3.17164 19.006 4.63647 18.5541 5.96565C18.3887 6.4522 17.8911 7.0032 17 7.79912"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15 14.5L15.6 15V15C17.2605 16.3838 18.0908 17.0757 18.3678 17.6012C19.1922 19.1654 18.4919 21.0997 16.8572 21.7736C16.3079 22 15.2272 22 13.0656 22H12C8.96159 22 7.44239 22 6.72234 21.5602C5.52426 20.8284 4.99392 19.3635 5.44581 18.0343C5.7174 17.2355 6.88448 16.2629 9.21865 14.3178L14.7813 9.68221C17.1155 7.73707 18.2826 6.7645 18.5542 5.96565C19.0061 4.63647 18.4757 3.17164 17.2777 2.43983C16.5576 2 15.0384 2 12 2H10.9344C8.77283 2 7.69206 2 7.14281 2.22641C5.5081 2.90028 4.80779 4.83458 5.63221 6.39878C5.90921 6.92434 6.73947 7.61623 8.4 9V9L9 9.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g clipPath="url(#clip0_2004_790)">
				<path
					opacity="0.32"
					d="M11.9998 1.25C8.39585 1.25 6.5939 1.25 5.74398 1.77977C4.37412 2.63364 3.76588 4.31362 4.27161 5.84655C4.58538 6.79763 5.96968 7.95121 8.73828 10.2584L9.40375 10.8129C9.86351 11.1961 10.0934 11.3876 10.1878 11.612C10.2923 11.8601 10.2923 12.1399 10.1878 12.388C10.0934 12.6124 9.86351 12.8039 9.40375 13.1871L8.73828 13.7416C5.96968 16.0488 4.58538 17.2024 4.27161 18.1535C3.76588 19.6864 4.37412 21.3664 5.74398 22.2202C6.5939 22.75 8.39585 22.75 11.9998 22.75C15.6037 22.75 17.4056 22.75 18.2555 22.2202C19.6254 21.3664 20.2336 19.6864 19.7279 18.1535C19.4141 17.2024 18.0298 16.0488 15.2612 13.7416L14.5958 13.1871C14.136 12.8039 13.9061 12.6124 13.8117 12.388C13.7072 12.1399 13.7072 11.8601 13.8117 11.612C13.9061 11.3876 14.136 11.1961 14.5958 10.8129L15.2612 10.2584C18.0298 7.95121 19.4141 6.79763 19.7279 5.84655C20.2336 4.31362 19.6254 2.63364 18.2555 1.77977C17.4056 1.25 15.6037 1.25 11.9998 1.25Z"
					fill="currentColor"
				/>
				<path
					d="M11.1028 22.75H12.8968C15.7615 22.75 17.1939 22.75 17.9072 22.4108C19.6384 21.5876 20.3853 19.5248 19.5823 17.784C19.2515 17.0668 18.1511 16.1498 15.9503 14.3159L15.9503 14.3158C15.8507 14.2329 15.801 14.1914 15.7478 14.1574C15.6229 14.0776 15.4819 14.0266 15.3349 14.0079C15.2723 14 15.2075 14 15.0779 14H8.92163C8.79199 14 8.72717 14 8.66458 14.0079C8.51759 14.0266 8.37657 14.0776 8.25173 14.1574C8.19856 14.1914 8.14877 14.2329 8.04919 14.3159L8.04918 14.3159C5.84841 16.1498 4.74802 17.0668 4.41721 17.784C3.61425 19.5248 4.36109 21.5876 6.09236 22.4108C6.80561 22.75 8.23799 22.75 11.1028 22.75Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_790">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
]);
